<div class="content">
  <svg viewBox="0 0 10 6"></svg>

  <div class="size">
    <img [src]="'https://nowypanel.zalamo.com/assets/images/003_mp.jpg'" />
    <img
      [style.opacity]="a"
      class="mask"
      src="http://localhost:5000/maski/Ramki/sciana_maska.png"
    />
    <div class="img1">
      <img #img1 />
      <div></div>
    </div>
    <div class="img2">
      <img #img2 src="https://zalamo.com/samples/wed2.jpg" />
      <div></div>
    </div>
    <img src="http://localhost:5000/maski/Ramki/ramki_szybki_t_cienie.png" />
  </div>
</div>
<svg>
  <defs>
    <filter color-interpolation-filters="sRGB" id="colorize">
      <feColorMatrix
        type="matrix"
        values="1 0 0 0 .255
               0 0 0 0 .0
               0 0 0 0 .0
               0 0 0 1 0"
      />
    </filter>
  </defs>
</svg>
<button (click)="showMenu()" class="options" mat-fab>
  <mat-icon>menu</mat-icon>
</button>

<ng-template #menu>
  <div class="menu">
    <mat-form-field>
      <mat-label>Kolor ściany</mat-label>
      <mat-select [(ngModel)]="color">
        <mat-option value="001">Szary</mat-option>
        <mat-option value="002">Niebieski</mat-option>
        <mat-option value="003">Pomarańczowy</mat-option>
      </mat-select>
    </mat-form-field>
    <p>
      <button mat-raised-button>
        Pierwsze zdjęcie
        <input (change)="uploadImage(1, $event)" type="file" />
      </button>
    </p>
    <button mat-raised-button>
      Drugie zdjęcie
      <input (change)="uploadImage(2, $event)" type="file" />
    </button>
  </div>
</ng-template>
